<div *ngIf="!trailData" style="width: 675px; height: 636px; display: flex; justify-content: center; align-items: center;"><mat-spinner></mat-spinner></div>
<div *ngIf="trailData" style="width: 675px; height: 636px; display: flex; justify-content: space-between;">
    <!-- <h1 mat-dialog-title><b>Vessel Details</b></h1> -->
    <div *ngFor="let temp of filtered" style="width: 340px; height: 604px;">
        <section
            style="width: 300px; height: 24px; font-size: 26px; line-height: 24px; font-weight: bold; color: #27364B;">
            {{ship}}</section>
        <!-- <section
            style="width: 62px; height: 19px; color: #64748B; font-weight: 400; margin-top: 8px; font-size: 16px; line-height: 18.75px;">
            Operator</section>
        <section
            style="width: 155px; height: 19px; font-size: 16px; line-height: 18.75px; font-weight: 700; color: #27364B;">
            {{temp.master_operator}}</section> -->
        <section
            style="margin-top: 32px; width: 70px; height: 19px; color: #64748B; font-size: 16px; font-weight: 400; line-height: 18.75px;">
            Last port</section>
        <section
            style="width: 155px; height: 19px; font-size: 16px; line-height: 18.75px; font-weight: 700; color: #27364B;">
            {{temp.stop_port_name | titlecase}}, {{temp.stop_port_UNlocode.slice(0,2)  | uppercase}}</section>
        <section
            style="margin-top: 8px; width: 88px; height: 19px; font-size: 16px; line-height: 18.75px; font-weight: 400; color: #64748B;">
            Departed on</section>
        <section
            style="width: 122px; height: 19px; font-size: 16px; line-height: 18.75px; font-weight: 700; color: #27364B;">
            {{temp.start_port_time| date:'d MMM y'}}</section>
        <section
            style="margin-top: 32px; width: 107px; height: 19px; font-size: 16px; line-height: 18.75px; font-weight: 400; color: #64748B;">
            Next port (AIS)</section>
        <section
            style="width: 158px; height: 19px; font-size: 16px; line-height: 18.75px; font-weight: 700; color: #27364B;">
            {{temp.destination}}</section>
        <section
            style="margin-top: 8px; width: 29px; height: 19px; font-size: 16px; line-height: 18.75px; font-weight: 400; color: #64748B;">
            ETA</section>
        <section
            style="width: 95px; height: 19px; font-size: 16px; line-height: 18.75px; font-weight: 700; color: #27364B;">
            {{temp.eta_time | date:'d MMM y'}}</section>
        <div style="display: flex; justify-content: space-between; margin-top: 40px;">
            <div style="width: 180px; height: 76px;">
                <section style="font-size: 16px; line-height: 18.75px; font-weight: 400; color: #64748B;">Vessel age
                </section>
                <section style="font-size: 16px; line-height: 18.75px; font-weight: 400; color: #64748B;">Tank type
                </section>
                <section style="font-size: 16px; line-height: 18.75px; font-weight: 400; color: #64748B;">No. of tanks
                </section>
                <section style="font-size: 16px; line-height: 18.75px; font-weight: 400; color: #64748B;">DWT</section>
            </div>
            <div style="width: 120px; height: 76px; text-align: right; margin-left: 24px;">
                <section style="font-size: 16px; line-height: 18.75px; font-weight: 700; color: #27364B;">{{temp.age}}
                </section>
                <section style="font-size: 16px; line-height: 18.75px; font-weight: 700; color: #27364B;">
                    {{temp.tank_type}}</section>
                <section style="font-size: 16px; line-height: 18.75px; font-weight: 700; color: #27364B;">{{temp.Tanks}}
                </section>
                <section style="font-size: 16px; line-height: 18.75px; font-weight: 700; color: #27364B;">{{temp.DWT |
                    number}}</section>
            </div>
            
        </div>
        <div style="display: flex; justify-content: space-between; margin-top: 25px;">
            <div style="width: 180px; height: 170px;">
                <section style="font-size: 16px; line-height: 18.75px; font-weight: 400; color: #64748B;">LOA
                </section>
                <section style="font-size: 16px; line-height: 18.75px; font-weight: 400; color: #64748B;">Beam
                </section>
                <section style="font-size: 16px; line-height: 18.75px; font-weight: 400; color: #64748B;">Draft (Current)
                </section>
                <section style="font-size: 16px; line-height: 18.75px; font-weight: 400; color: #64748B;">Draft (@ Summer LL)</section>
                <section style="font-size: 16px; line-height: 18.75px; font-weight: 400; color: #64748B;">Total cubic capacity
                </section>
                <section style="font-size: 16px; line-height: 18.75px; font-weight: 400; color: #64748B; height: 60px;">Notes</section>
                <section style="font-size: 16px; line-height: 18.75px; font-weight: 400; color: #64748B;">Nitrogen generator
                </section>
                <section style="font-size: 16px; line-height: 18.75px; font-weight: 400; color: #64748B;">Max heat temperature `C
                </section>
                <section style="font-size: 16px; line-height: 18.75px; font-weight: 400; color: #64748B;">Min cool temperature `C</section>
                <section style="font-size: 16px; line-height: 18.75px; font-weight: 400; color: #64748B;">Max carriage press</section>
            </div>
            <div style="width: 100px; height: 170px; margin-left: 24px; text-align: right;">
                <section style="font-size: 16px; line-height: 18.75px; font-weight: 700; color: #27364B;">{{metadata?.LOA}}
                </section>
                <section style="font-size: 16px; line-height: 18.75px; font-weight: 700; color: #27364B;">
                    {{metadata?.Beam}}</section>
                <section style="font-size: 16px; line-height: 18.75px; font-weight: 700; color: #27364B;" *ngIf="trailData">{{trailData[0].draught || "---"}}
                </section>
                <section style="font-size: 16px; line-height: 18.75px; font-weight: 700; color: #27364B;">{{metadata?.Draft}}</section>
                    <section style="font-size: 16px; line-height: 18.75px; font-weight: 700; color: #27364B;">{{metadata?.CBM|
                        number}}
                    </section>
                    <section style="font-size: 16px; line-height: 18.75px; font-weight: 700; color: #27364B; height: 60px;">{{metadata.Other_Data || "---"}}
                     </section>
                    <section style="font-size: 16px; line-height: 18.75px; font-weight: 700; color: #27364B;">
                        Unknown</section>
                    <section style="font-size: 16px; line-height: 18.75px; font-weight: 700; color: #27364B;">Unknown
                    </section>
                    <section style="font-size: 16px; line-height: 18.75px; font-weight: 700; color: #27364B;">Unknown</section>
                    <section style="font-size: 16px; line-height: 18.75px; font-weight: 700; color: #27364B;">Unknown</section>
            </div>
        </div>
        
        <!-- <p>DWT: {{temp.DWT}}</p>
 <p>Tanks: {{temp.Tanks}}</p> -->
    </div>
    <!-- <div mat-dialog-actions>
 <button mat-button (click)="close()" style="justify-content: center;">Close</button>
 </div> -->
    <div >
        <!-- <agm-map (mapReady)="mapReading()" [latitude]='lat' [longitude]='lng' [styles]="style" [zoom]="zoom"
            [fitBounds]="true" [restriction]="countryRestriction">
            <agm-marker [latitude]="markerLat" [longitude]="markerLong" [agmFitBounds]="true" [iconUrl]="{
                path: 'm0.812665,23.806608l37.937001,-22.931615l-21.749812,38.749665l1.374988,-17.749847l-17.562177,1.931797z',
                fillColor:'green',
                fillOpacity: 1.0,
                scale: .25,
                strokeColor:'green'
            }">
                <agm-circle *ngFor="let marker of trailData; let i=index" [latitude]="marker.Latitude" [longitude]="marker.Longitude"
                    [fillOpacity]="1" [radius]="trailData?.length == 1 ? 700 : 10000" [fillColor]="'red'"></agm-circle>
                <agm-polyline [visible]="true" [strokeWeight]="2" [strokeColor]="'#008ECF'">
                    <agm-polyline-point [agmFitBounds]="true" *ngFor="let marker of trailData; let i=index "
                        [latitude]="marker.Latitude" [longitude]="marker.Longitude">

                    </agm-polyline-point>
                    <agm-icon-sequence [fixedRotation]="false" [offset]="100"
                        [path]="'FORWARD_OPEN_ARROW'">
                    </agm-icon-sequence>
                </agm-polyline>

            </agm-marker>

        </agm-map> -->
        <div style="margin-top: 23px;">
            <span style="width: 50px; height: 19px; font-size: 16px; line-height: 19px; color:#64748B;">Region</span>
            <span style="width: 83px; height: 19px; font-size: 16px; line-height: 19px; color:#64748B; margin-left: 162px;">Confidence</span>
        </div>
        <div>
            <span style="width: 106px; height: 24px; font-size: 26px; line-height: 24px; font-weight: bold; color: #27364B;">Houston</span>
            <span style="width: 106px; height: 24px; font-size: 26px; line-height: 24px; font-weight: bold; color: #27364B; margin-left: 130px;" *ngFor="let marker of filtered">{{marker.probability | number : '1.0-0'}}%</span>
        </div>
        <div style="margin-top: 28px; justify-content: space-between; display: flex;">
            <span style="width: 110px; height: 19px; font-size: 16px; line-height: 19px; font-weight: bold; color: #27364B;">Previous port</span>
            <span style="width: 96px; height: 19px; font-size: 16px; line-height: 19px; font-weight: bold; color: #27364B; text-align: center; ">Laytime</span>
            <span style=" width: 88px; height: 19px; font-size: 16px; line-height: 19px; font-weight: bold; color: #27364B;">Arrival Draft</span>
        </div>
        <div style="display: flex; justify-content: space-between;" *ngFor="let marker of trailData.reverse();">
            <div style="width: 120px; height: fit-content;" >
                <span style="font-size: 16px; line-height: 18.75px; font-weight: 500; color: #64748B; word-wrap: break-word;">
                    {{marker.stop_port_name | titlecase}}, {{marker.stop_port_UNlocode.slice(0,2)  | uppercase}}</span>
            </div>
            <div style="width: 104px; height: fit-content; text-align: center;  ">
                <span style="font-size: 16px; line-height: 18.75px; font-weight: 500; color: #27364B;">{{marker.arrivalTime | date:'d MMM':'UTC' }}-{{marker.departureTime | date:'d MMM':'UTC'}}</span>
            </div>
            <div style="width: 80px; height: fit-content; text-align: right;">
                <span style="font-size: 16px; line-height: 18.75px; font-weight: 500; color: #27364B;">{{marker.draught}}</span>
            </div>
        </div>
    </div>
    
</div>